// extracted by css-extract-rspack-plugin
export default {"footer":"R5OQ5QYWz9Ea8xNU","footerActions":"S52868ZOcjcwqwt2","stepIndicator":"fuBxV4kfHYQdhXYJ"};